// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"621":"7bba7114","806":"3f1aa1bd"}[chunkId] + ".chunk.css";
};